import {Injectable} from '@angular/core';
import {BehaviorSubject, combineLatestWith, Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import * as R from 'ramda';
import * as RA from 'ramda-adjunct';
import {ManagementStoreService} from './management-store.service';
import {ManagementApiService} from '@emm/management/services/management-api.service';
import {genericSort} from '@emm/core/util/sort.util';
import {formatFieldName} from '@emm/core/util/string-format.util';
import {GenericItem} from '@emm/core/models/context-menu-action.model';
import {Attribute} from '@emm/core/models/attribute.model';
import {SearchFilter} from '@emm/core/models/search-filter';

@Injectable({providedIn: 'root'})
export class AttributesFacadeService {

    attributeDetail$ = new BehaviorSubject<any>(null);
    attributes$ = new BehaviorSubject<any>(undefined);
    attributesAsGenericItems$ = this.attributes$.pipe(
        filter(RA.isNotNil),
        map(attributes =>
            attributes.sort(genericSort(a => a['name']))
                .map(attribute => (
                    {
                        name: formatFieldName(attribute.name),
                        tag: attribute.tag,
                        disabled: false,
                        source: attribute
                    } as GenericItem<Attribute>
                ))));

    attributeTypes$ = this.api.getAllAttributeTypes();

    centerLoading$ = this.managementStore.isLoading$.attributes;
    rightLoading$ = this.managementStore.isLoading$.base;
    anyLoading$ = this.centerLoading$.pipe(
        combineLatestWith(this.rightLoading$),
        map((sources: boolean[]) => R.any(R.equals(true), sources))
    );

    private addClicked$ = new BehaviorSubject<boolean>(false);

    constructor(private managementStore: ManagementStoreService,
                public api: ManagementApiService) {
    }

    init() {
        this.managementStore.dispatch.initAttributes();
    }

    selectAttribute(attribute: Attribute) {
        let attributeDetail;
        this.api.getAttribute(attribute.tag).subscribe(result => {
            attributeDetail = result;
            this.attributeDetail$.next(attributeDetail);
        });
    }

    searchAttributes(searchFilter: SearchFilter): void {
        this.managementStore.dispatch.searchAttributes(searchFilter);
    }

    openAddDialog() {
        this.managementStore.dispatch.openAddAttributeDialog();
    }

    startProgressBar(): void {
        this.managementStore.dispatch.startLoading();

    }
    stopProgressBar(): void {
        this.managementStore.dispatch.stopLoading();
    }

    public nextAddClicked(value: boolean): void {
        this.addClicked$.next(value);
    }

    public onAddClicked(): Observable<boolean> {
        return this.addClicked$.asObservable();
    }

    getAllItemTypes() {
        return this.api.getAllItemTypes();
    }

    updateAttribute(attribute: Attribute) {
        return this.api.updateAttribute(attribute);
    }
}
